import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Carat, RotateClockwise } from '../Icons';
import * as Styles from './styles';
export const DropdownButton = function DropdownButton({ active, children, ref, ...rest }) {
    const caratPosition = active ? RotateClockwise.QuarterReverse : RotateClockwise.Quarter;
    return (_jsxs(Styles.Button, { ref: ref, active: active, ...rest, children: [_jsx(Styles.Text, { children: children }), _jsx(Styles.Icon, { children: _jsx(Carat, { rotateClockwise: caratPosition, transition: '0.6s' }) })] }));
};
//# sourceMappingURL=index.js.map